export interface SelectItem {
    value: number,
    title: string
}

export interface DoseUnit {
    value: DoseUnitEnum,
    title: string
}

export enum DoseUnitEnum {
    "µg/kg/min",
    "µg/kg/hod",
    "µg/min",
    "mg/hod",
    "mg/kg/hod"
}
